function initGiftLock() {
  console.log('🎁 Initializing gift-lock (Dawn compatible)');

  const bars = document.querySelectorAll('.kaching-bundles__bar');
  if (!bars.length) {
    console.warn('⏳ Waiting for Kaching bundles...');
    return;
  }

  const cards = document.querySelectorAll('.bonus-card');
  if (!cards.length) {
    console.warn('❌ No bonus cards found');
    return;
  }

  const totalValueEl = document.querySelector('.gift-total-value');

  const TOTALS = {
    1: '<s>88,99 €</s> 39,99 €',
    2: '<s>149,99 €</s> 69,98 €',
    3: '<s>210,89 €</s> 98,97 €',
    4: '<s>263,86 €</s> 119,96 €'
  };

  // Kaching deal bar ID -> number of pillows
  const BAR_QTY = {
    // French IDs
    'q-Yq': 2, // Duo (current)
    'cz5E': 1, // Single
    'W7rr': 2,
    'wS26': 3,
    'qVG5': 4,
    // Italian IDs
    '27fc868b-d981-4184-bd26-14c5fbd04127': 1,
    '44693a5e-f331-47af-aab8-e77526683ca9': 2
  };

  function updateHeader(card, qty) {
    const p = card.querySelector('.bonus-header p');
    if (!p) return;

    p.innerText = p.innerText.replace(/^\d+x\s*/, '');
    p.innerText = `${qty}x ` + p.innerText;
  }

  function lockCard(card, locked) {
    card.classList.toggle('locked', locked);
  }

  function lockGifts(qty) {
    console.log(`🔄 lockGifts(${qty})`);

    cards.forEach((card, index) => {
      if (index === 0 || index === 1) {
        updateHeader(card, qty);
      }

      // Card 4 = Livraison offerte: unlocked from Duo
      if (index === 3) {
        lockCard(card, qty < 2);
      } else {
        lockCard(card, false);
      }
    });

    if (totalValueEl) {
      totalValueEl.innerHTML = TOTALS[qty] || '';
    }
  }

  // Initial state = the bar Kaching has selected (Duo by default)
  const selected = document.querySelector('.kaching-bundles__bar--selected');
  lockGifts((selected && BAR_QTY[selected.dataset.dealBarId]) || 2);

  // Delegated listener: keeps working if Kaching re-renders the bars
  document.addEventListener('click', e => {
    const bar = e.target.closest('.kaching-bundles__bar');
    if (!bar) return;
    const qty = BAR_QTY[bar.dataset.dealBarId];
    if (qty) lockGifts(qty);
  });

  console.log('✅ Gift-lock ready');
}

/* Retry until Kaching loads */
let tries = 0;
const waitForBundles = setInterval(() => {
  if (document.querySelector('.kaching-bundles__bar') || tries++ > 20) {
    clearInterval(waitForBundles);
    initGiftLock();
  }
}, 400);